<div
  class="line"
  [class.first]="first"
  [rkDndDraggable]="track"
  [dndType]="'playlist_manual'"
  [dndDragImageOffsetFunction]="dndDragImageOffsetFunction"
>
  <img [src]="track.cover" />
  <div class="play-pause-button-container">
    <rk-icon-button
      [bordered]="true"
      [faIcon]="isLoaded && isPlaying ? 'fa-pause' : 'fa-play'"
      [size]="25"
      [style]="{ width: '36px', height: '36px' }"
      (click)="playTrack(track)"
    >
    </rk-icon-button>
  </div>
  <div class="track">
    <span class="title">{{ track.title }}</span>
    <span class="artist">{{ track.artist }}</span>
  </div>
  <div class="time">{{ track.timeSeconds ? (track.timeSeconds | timeFormat) : '' }}</div>
  <div class="time time-hover">
    <rk-button
      btnStyle="orange"
      faIcon="fa-plus"
      (click)="addTrackToPlaylist(track.id)"
    ></rk-button>
  </div>
  <div rkDragImageRef class="drag-style">
    <span class="bigger" [ngClass]="{ 'no-artist': !track.artist }">{{
      track.title
    }}</span>
    <span *ngIf="track.artist"> - {{ track.artist }}</span>
  </div>
</div>
